namespace TabAurous.HR {
    export interface LeaveAllocationForm {
        LeaveTypeId: Serenity.IntegerEditor;
        EmployeeId: Serenity.IntegerEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
        Leaves: Serenity.IntegerEditor;
    }

    export class LeaveAllocationForm extends Serenity.PrefixedContext {
        static formKey = 'HR.LeaveAllocation';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LeaveAllocationForm.init)  {
                LeaveAllocationForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;

                Q.initFormType(LeaveAllocationForm, [
                    'LeaveTypeId', w0,
                    'EmployeeId', w0,
                    'FromDate', w1,
                    'ToDate', w1,
                    'Leaves', w0
                ]);
            }
        }
    }
}
